import React from 'react';
import SectionHeading from '../../Common/SectionHeading';
import Image from 'next/image';

const TrackingCoverageSection = ({title=null}) => {
  return (
    <section className="w-11/12 xl:max-w-screen max-w-screen-2xl mx-auto lg:my-8 my-4">
      {(title) &&
          <SectionHeading title={title}  customClass="text-center"/>
        }
      <div className="grid grid-cols-12 gap-8">
        <div className="lg:col-span-6 col-span-12"> 
          <p className="text-base">Monitoring the competitors is essential to understand their behaviors and actions, helping companies adapt quickly to market changes, learn customer demands, solve industry issues, and make better business decisions. </p>
          <p className="text-base">DelveInsight’s expertise in Competitive Intelligence Tracking helps clients in strengthen their brand’s market position and keep them updated with current industry trends. DelveInsight provides unmatched consulting services and actionable competitive intelligence to enable businesses to gain a distinctive advantage. We help determine where to play and how to win. </p>
        </div>
        <div className="lg:col-span-6 col-span-12">
          <div className="col-lg-12 pl-0">
            <div className="align-items-start flex lg:flex-col flex-row">
              <div className="mr-4">
                <div className="rounded-circle text-white d-flex align-items-center justify-content-center lg:w-16 lg:h-16 w-10 h-10" >
                  <Image 
                    priority={false} 
                    width={2000} 
                    height={2000} 
                    src={process.env.IMG_CDN+'img/consulting/jpg/ci-tracking/regulatory-and-commercial-monitoring.svg'}
                    alt="Regulatory and Commercial Monitoring" 
                  />
                </div>
              </div>
              <div>
                <h4 className="text-xl font-semibold">Regulatory and Commercial Monitoring</h4>
              </div>
            </div>
            <p className="text-base mt-0">Regulatory monitoring involves keeping track of laws and regulations that govern healthcare approvals and regulations, such as monitoring regulation changes and ensuring that client partners are aware of the dynamism. Commercial monitoring involves tracking the commercial activities of healthcare organizations and providers, such as mergers and acquisitions, partnerships, and advertising.</p>
          </div>
        </div>
      </div>
      <div className="grid grid-cols-12 gap-8 lg:mt-4">
        <div className="lg:col-span-6 col-span-12">
            <div className="align-items-start flex lg:flex-col flex-row">
                <div className="mr-4">
                    <div className="rounded-circle text-white d-flex align-items-center justify-content-center lg:w-16 lg:h-16 w-10 h-10" >
                        <Image 
                          priority={false} 
                          width={2000} 
                          height={2000} 
                          src={process.env.IMG_CDN+'img/consulting/jpg/ci-tracking/r&d-and-clinical-trial-monitoring.svg'}
                          alt="R&D and Clinical Trial Monitoring" 
                        />
                    </div>
                </div>
                <div>
                    <h4 className="text-xl font-semibold">R&D and Clinical Trial Monitoring</h4>
                </div>
            </div>
            <p className="text-base mt-0 mb-0">Real-time tracking can monitor the progress of developmental assets and clinical trials, including changes in the developmental phase, patient recruitment and retention, adverse events, and data quality. This can help companies identify potential issues early on and take corrective action.</p>
        </div>
        <div className="lg:col-span-6 col-span-12">
            <div className="align-items-start flex lg:flex-col flex-row">
                <div className="mr-4">
                    <div className="rounded-circle text-white d-flex align-items-center justify-content-center lg:w-16 lg:h-16 w-10 h-10" >
                        <Image 
                          priority={false} 
                          width={2000} 
                          height={2000} 
                          src={process.env.IMG_CDN+'img/consulting/jpg/ci-tracking/social-media-monitoring.svg'}
                          alt="Social Media Monitoring" 
                        />
                    </div>
                </div>
                <div>
                    <h4 className="text-xl font-semibold">Social Media Monitoring</h4>
                </div>
            </div>
            <p className="text-base mt-0">Real-time tracking can monitor social media platforms like Twitter, Facebook, and LinkedIn to track mentions of specific drugs, their efficacy, side effects, and user feedback. This can help pharmaceutical companies identify key opinion leaders & gather insights into consumer opinions and preferences.</p>

        </div>
      </div>
    </section>
  );
};

export default TrackingCoverageSection;